import { h, render } from 'preact';
const FourOhFour = () => h("h1", null, "404");
export default FourOhFour;
